// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"667.98","sm":"947.98","md":"1023.98","lg":"1229.98","container":"WYtb+8UC","figure":"scNvU0Dz","content":"Wa3PRhuV","inner":"_4Qwiqh5a","circles":"NNeTPkWy"};